import { useState, useEffect } from 'react';
import { MsalProvider, useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import msalInstance from './authentication/authconfig.js';
import AuthContext from './authentication/auth_context';
import LoginButton from './authentication/LoginButton.js';
import logo from './logo.svg';
import './App.css';
import Dashboard from './components/dashboard.js';
import { ApiProvider } from './context/ApiContext';

function App() {
  const [username, setUsername] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [theme, setTheme] = useState('dark');
  const { accounts } = useMsal();
  const [logisticsContacts, setLogisticsContacts] = useState([]);
  //const baseApiUrl = 'https://localhost:44383';
  const baseApiUrl = 'https://salesapi.duvelusa.com';

  useEffect(() => {
    console.log(accounts)
    if (accounts.length > 0) {
      setUsername(accounts[0].username);
    }
  }, [accounts]);

  const handleLogin = (username) => {
    setUsername(username);
  };

  const handleLogout = () => {
    try {
      // Remove the msal.account.keys entry from session storage
      sessionStorage.removeItem('msal.account.keys');
      // Optionally, you can also clear other MSAL-related entries from session storage
      sessionStorage.removeItem('msal.idtoken');
      sessionStorage.removeItem('msal.client.info');      
      window.location.reload();
    }
    catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    //
    //first check for new version
    //and reload if necessary
    //


    fetch(`${baseApiUrl}/api/Sales/GetCurrentVersion`)
      .then(response => response.json())
      .then(data => {
        const latestVersion = data.version;
        const currentVersion = localStorage.getItem('dusa_beerportal_appVersion');
    
        if (!currentVersion || latestVersion > currentVersion) {
          //setNewVersionAvailable(true);
          localStorage.setItem('dusa_beerportal_appVersion', latestVersion);
          window.location.reload(true);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });

    //
    //then do the auth stuff
    //
    //const authConfig = environment.authConfig;
    //console.log('authConfig: ', authConfig);
    const myAccounts = msalInstance.getAllAccounts();
    console.log("Accounts from instance: ", myAccounts);
    if (myAccounts && myAccounts[0]) {
      console.log("idTokenClaims: ", myAccounts[0].idTokenClaims);
      console.log("account groups: ", myAccounts[0].idTokenClaims.groups);
    }   
    if (myAccounts && myAccounts[0]) {
      //console.log("username: ", myAccounts[0].username);
      setUsername(myAccounts[0].username);
  
      // Check if the array contains the value
      if (myAccounts && myAccounts[0]) {
        if (myAccounts[0].idTokenClaims.groups.includes('899d39ff-09b7-41e1-8116-e186b9a5d7a8')) {
          setIsAdmin(true);
          console.log("isAdmin: ", isAdmin);

          // fetch(`${baseApiUrl}/api/Sales/GetAllLogisticsContacts`)
          // .then(response => response.json())
          // .then(data => {
          //   console.log("Logistics contacts data:", data);
          //   setLogisticsContacts(data);
          // })
          // .catch(error => console.error('Error fetching logistics contacts:', error));

        }  
      }
    }
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <ApiProvider baseUrl={baseApiUrl}>
        <div className="App" style={{backgroundColor: 'rgb(227, 230, 230)', paddingBottom: '100px'}}>
          <AuthenticatedTemplate>
          {/* <div style={{ textAlign: 'center'}}>
            <span>user: {username}</span>
            <div><button onClick={handleLogout}>Logout</button></div>
          </div> */}
            <Dashboard version={localStorage.getItem('dusa_beerportal_appVersion')} username={username} isAdmin={isAdmin} />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <LoginButton onLogin={handleLogin} />
          </UnauthenticatedTemplate>
        </div>
      </ApiProvider>
    </MsalProvider>
  );
}

export default App;
